<div fxLayout="row" fxLayoutAlign="center center" class="naturaImg">
  <img src="../assets/natura-logo.svg" width="100%" style="max-width: 350px; " />
</div>
<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">
  <mat-card class="box">
    <button mat-icon-button [routerLink]="['/recovery']" >
      <mat-icon>arrow_back</mat-icon>
      </button>
    <mat-card-header>
      <div align="center">
        <h2> Ingresa el código que recibiste: </h2>
      </div>
    </mat-card-header>
    <form class="example-form">
      <mat-card-content>
        <div align="center">
        <ng-otp-input matInput #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent"
          [config]="config"></ng-otp-input>
        </div>
      </mat-card-content>
      <div align="center">
        <button mat-stroked-button color="" (click)="validateCode('newpassword')" class="button-send" [disabled]="otp.length < 8 ">VERIFICAR</button>
      </div>
      <div style="margin-top: 50px;;" align="center">
        <div style="font-size: 16px; color: #A1A1A1;"> ¿No recibiste el código?</div>
        <br />
        <button mat-stroked-button color="" (click)="openDialog()" class="button-resend">REENVIAR</button>
       
        <div class="textCode"> Ten en cuenta que el código puede demorar algunos minutos en llegarte.</div>
      </div>
    </form>
  </mat-card>
</div>

<div fxLayout="row" fxLayoutAlign="center center" class="logoPowered">
  <img src="../assets/powered by Gera.svg" width="100%" style="max-width: 150px; position: relative;" />
</div>
<br />